import { useState, useEffect, useMemo } from 'react';
import { useSelector } from 'react-redux';
import { getBlockTypesForDeviation, getHighestPriorityBlockReasonForDeviation } from '../../Moderation/redux/selectors';
import { BlockReasons } from '../../Moderation/redux/types';
import isEqual from 'lodash/isEqual';
const matureReasons = [
    BlockReasons.MatureAge,
    BlockReasons.MatureFilter,
    BlockReasons.Nsfg
];
export function useDeviationMatureFilter(deviation) {
    const blockReasons = useSelector((state)=>getBlockTypesForDeviation(state, deviation), isEqual);
    const displayReason = useSelector((state)=>getHighestPriorityBlockReasonForDeviation(state, deviation));
    const [matureFilterDisabled, setMatureFilterDisabled] = useState(false);
    // reset mature filter override when deviation changes
    const { deviationId = 0 } = deviation || {};
    useEffect(()=>{
        setMatureFilterDisabled(false);
    }, [
        deviationId
    ]);
    const hasNonOverridableBlockReasons = blockReasons.some((reason)=>!matureReasons.includes(reason));
    const hasOverridableMatureBlockReasons = blockReasons.some((reason)=>matureReasons.includes(reason));
    const props = useMemo(()=>({
            showBlocked: hasNonOverridableBlockReasons || hasOverridableMatureBlockReasons && !matureFilterDisabled,
            overrideMatureFilter: ()=>setMatureFilterDisabled(true),
            displayReason
        }), [
        hasNonOverridableBlockReasons,
        hasOverridableMatureBlockReasons,
        matureFilterDisabled,
        displayReason
    ]);
    return props;
}

//# sourceMappingURL=useDeviationMatureFilter.js.map